import { render, staticRenderFns } from "./newversion.vue?vue&type=template&id=60226b6e&scoped=true&"
import script from "./newversion.vue?vue&type=script&lang=js&"
export * from "./newversion.vue?vue&type=script&lang=js&"
import style0 from "./newversion.vue?vue&type=style&index=0&id=60226b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60226b6e",
  null
  
)

export default component.exports